import { Link, Text } from "@wayflyer/flyui";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";
import { handleContactTeam } from "shared-utils";

import { COMMON_MESSAGES } from "../common-messages";

/**
 * `renderConnectAnother` for connectors that don't support multiple connections
 * (`multipleConnectionsAllowed: false`) - points the customer at support instead of a working
 * add-another flow, since a second OAuth login would silently merge into the same connection.
 */
export const ConnectAnotherAccountSupportLink = () => {
  const intl = useIntl();
  return (
    <Text size="sm">
      {intl.formatMessage(COMMON_MESSAGES.connectAnotherAccountContactSupport, {
        link: (chunks: ReactNode) => <Link onClick={handleContactTeam}>{chunks}</Link>,
      })}
    </Text>
  );
};
